document.addEventListener('DOMContentLoaded', () => {
  const validationForm = document.querySelector('.validationForm');
  if (validationForm) {
    const errorClassName = 'error';

    const requiredElems = document.querySelectorAll('.js-required');
    const emailElems = document.querySelectorAll('.js-email');
    const requiredCheckbox = document.querySelector('.js-required-checkbox'); // 個別のチェックボックス
    const confirmButton = document.querySelector('.contact__button');

    //エラーメッセージを表示する span 要素を生成して親要素に追加する関数
    //elem ：対象の要素
    //errorMessage ：表示するエラーメッセージ
    const createError = (elem, errorMessage) => {
      //span 要素を生成
      const errorSpan = document.createElement('span');
      //エラー用のクラスを追加（設定）
      errorSpan.classList.add(errorClassName);
      //aria-live 属性を設定
      errorSpan.setAttribute('aria-live', 'polite');
      //引数に指定されたエラーメッセージを設定
      errorSpan.textContent = errorMessage;
      //elem の親要素の子要素として追加
      elem.parentNode.appendChild(errorSpan);
    }

    //form 要素の submit イベントを使った送信時の処理
    confirmButton.addEventListener('click', (e) => {
      // 毎回バリデーション直前に取得するよう変更
      const requiredElems = validationForm.querySelectorAll('.js-required');
      const errorElems = validationForm.querySelectorAll('.' + errorClassName);
      errorElems.forEach((elem) => {
        elem.remove();
      });

      // 必須項目チェック
      requiredElems.forEach((elem) => {
        const elemValue = elem.value.trim();
        if (elemValue.length === 0) {
          createError(elem, '入力は必須です');
          e.preventDefault();
        }
      });

      //.email を指定した要素を検証
      emailElems.forEach((elem) => {
        //Email の検証に使用する正規表現パターン
        const pattern = /^([a-z0-9\+_\-]+)(\.[a-z0-9\+_\-]+)*@([a-z0-9\-]+\.)+[a-z]{2,6}$/ui;
        //値が空でなければ
        if (elem.value !== '') {
          //test() メソッドで値を判定し、マッチしなければエラーを表示してフォームの送信を中止
          if (!pattern.test(elem.value)) {
            createError(elem, 'Email アドレスの形式が正しくないようです。');
            e.preventDefault();
          }
        }
      });

      // プライバシーポリシー同意チェックボックスのバリデーション
      if (requiredCheckbox && !requiredCheckbox.checked) {
        createError(requiredCheckbox, '同意してください');
        e.preventDefault();
      }

      //エラーの最初の要素を取得
      const errorElem = validationForm.querySelector('.' + errorClassName);
      //エラーがあればエラーの最初の要素の位置へスクロール
      if (errorElem) {
        const errorElemRect = errorElem.getBoundingClientRect();
        const offsetTop = window.pageYOffset + errorElemRect.top;
        window.scrollTo({
          top: offsetTop - 200,  //100px 上に位置を調整
          //スムーススクロール
          behavior: 'smooth'
        });
      }
    });
  }
});

const requiredInputs = document.querySelectorAll('.field__input[aria-required="true"]');

function checkAllInputs() {
  let allFilled = true;

  requiredInputs.forEach(input => {
    if (!input.value.trim()) {
      allFilled = false;
    }
  });

  if (allFilled) {
    const button = document.querySelector('.contact__button .button');
    if (button) {
      button.removeAttribute('disabled');
      button.classList.add('is-active');
    }
  }
}

requiredInputs.forEach(input => {
  input.addEventListener('input', checkAllInputs);
});